import Nullstack from 'nullstack';
export default function IconBatteryAutomotive({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-battery-automotive",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "6",
    width: "18",
    height: "14",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M6 6v-2"
  }), "   ", Nullstack.element("line", {
    x1: "19",
    y1: "4",
    x2: "19",
    y2: "6"
  }), "   ", Nullstack.element("line", {
    x1: "6.5",
    y1: "13",
    x2: "9.5",
    y2: "13"
  }), "   ", Nullstack.element("line", {
    x1: "14.5",
    y1: "13",
    x2: "17.5",
    y2: "13"
  }), "   ", Nullstack.element("line", {
    x1: "16",
    y1: "11.5",
    x2: "16",
    y2: "14.5"
  }), " ");
}